








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  @Prop() private token: string;
  @Prop() private refreshToken: string;
  @Prop() private schoolId: string;

  private loading = false;

  private async created() {
    this.loading = true;
    if (!this.schoolId) {
      try {
        await this.$store.dispatch('auth/singleSignOn', {
          token: this.token,
          refreshToken: this.refreshToken,
        });
        switch (this.$route.query.view) {
          case 'creditcard':
            this.$router.push({ name: 'StudentCreditcard' });
            break;
          default:
            this.$router.push({ name: 'Top' });
        }
      } catch (error) {
        this.$router.push({ name: 'Login' });
      }
    } else {
      try {
        await this.$store.dispatch('auth/schoolSingleSignOn', {
          token: this.token,
          schoolId: this.schoolId,
        });
        switch (this.$route.query.view) {
          case 'creditcard':
            this.$router.push({ name: 'StudentCreditcard' });
            break;
          default:
            this.$router.push({ name: 'Top' });
        }
      } catch (error) {
        this.$router.push({ name: 'Login', query: { schoolId: this.schoolId } });
      }
    }
    this.loading = false;
  }

  private deactivated() {
    this.$destroy();
  }
}
